<template>
    <div>
        <public-menu></public-menu>
        <public-search></public-search>  
        <bottom-nav></bottom-nav>
        <public-footer></public-footer>
    </div>
</template>

<script>
import Public_menu from "@/components/common/public-top"
import Public_Search from "@/components/search/Index"
import Bottom_nav from "@/components/common/bottom-nav"
import Footer from "../../components/Footer.vue"
export default {
    components:{
        'public-menu': Public_menu,
        'public-search':Public_Search,
        'bottom-nav': Bottom_nav,
        'public-footer': Footer
    }
}
</script>

<style scoped>
@import url('../../assets/css/style.css');
</style>


// WEBPACK FOOTER //
// src/views/search/Index.vue